import { useCallback, useRef } from 'react';
export function useComputerCommandMenuKeyDownHandlers({ isOpen, onKeyDown, }) {
    const inputKeyDownHandlerRef = useRef(null);
    const handledKeyEventsRef = useRef(new WeakSet());
    const registerKeyDownHandler = useCallback((handler) => {
        inputKeyDownHandlerRef.current = handler;
        return () => {
            if (inputKeyDownHandlerRef.current === handler) {
                inputKeyDownHandlerRef.current = null;
            }
        };
    }, []);
    const handleKeyDown = useCallback((event) => {
        if (handledKeyEventsRef.current.has(event))
            return;
        if (isOpen) {
            const handledByCommandMenu = inputKeyDownHandlerRef.current?.(event);
            if (handledByCommandMenu) {
                handledKeyEventsRef.current.add(event);
                return;
            }
            if (event.defaultPrevented)
                return;
        }
        onKeyDown(event);
    }, [isOpen, onKeyDown]);
    return {
        registerKeyDownHandler,
        handleKeyDown,
    };
}
//# sourceMappingURL=useComputerCommandMenuKeyDownHandlers.js.map